<template>
  <TextInput
    v-model="organizerName"
    v-validate="{ required: hasOrganizer }"
    class="col-4 col-lg-3 h-text-left"
    :class="{ 'is-invalid': errors.first('organizer') }"
    :read-only="!hasOrganizer || isOrganizerDisabled"
    :disabled="!hasOrganizer || isOrganizerDisabled"
    :required="hasOrganizer && !isOrganizerDisabled"
    data-vv-name="organizer"
    :error="errors.first('organizer')"
    type="text"
    :label="$t('_web_tournaments_list_name', 'Name')"
    :placeholder="
      $t(
        '_web_tournament_organizer-name-placeholder',
        'Provide event organizer name'
      )
    "
    :data-vv-as="$t('_web_tournaments_list_name', 'Name')"
  />
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import TextInput from '@/components/atoms/form/HeraFormTextInput';
import { translate } from '@/mixins/translate';
export default {
  name: 'TournamentOrganizerNameSetting',
  inject: ['$validator'],
  components: {
    TextInput,
  },
  mixins: [translate('_web_tournament_settings')],
  data() {
    return {
      titleCopy: '',
    };
  },
  computed: {
    ...mapGetters(['currentTournament', 'isTournamentFieldDisabled']),
    hasOrganizer() {
      return this.$lodash.get(
        this.currentTournament,
        'info.event_organizer.isAvailable',
        false
      );
    },
    isOrganizerDisabled() {
      return this.isTournamentFieldDisabled('event_organizer');
    },
    organizerName: {
      get() {
        return (
          this.$lodash.get(
            this.currentTournament,
            'info.event_organizer.name',
            false
          ) || ''
        );
      },
      set(newVal) {
        this.updateEventOrganizer('name', newVal);
      },
    },
  },
  methods: {
    ...mapMutations(['updateCurrentTournament']),
    updateEventOrganizer(key, val) {
      const event_organizer = this.$lodash.cloneDeep(
        this.currentTournament.info.event_organizer
      );
      event_organizer[key] = val;
      this.updateCurrentTournament({
        event_organizer,
        component: 'info',
      });
    },
  },
};
</script>
